import { TPromotion } from '../../types/config';
import { Box } from '@mui/material';
import { useExtractColors } from 'react-extract-colors';
import { SECONDARY_PROMO_HEIGHT } from '.';
import { bgCss } from './utils';

type Props = TPromotion & {
  stretch: boolean;
  onClick: () => void;
};

export default function SecondaryPromo(data: Props) {
  const { darkerColor } = useExtractColors(data.bgImage || '');

  return (
    <>
      <Box
        sx={{
          position: 'relative',
          height: { xs: '100vw', sm: `${SECONDARY_PROMO_HEIGHT}px` },
          width: data.stretch ? 'auto' : '100%',
          borderRadius: '12px',
          margin: { xs: '0', sm: '0 0 10px 0' },
          border: { xs: 'none', sm: '1px solid #EAECF0' },
          boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
          backgroundColor: darkerColor,
          ...bgCss(data),
        }}
        flexGrow={data.stretch ? 1 : 'unset'}
        onClick={data.onClick}
      >
        {/* <BoxAbsolute
          sx={{
            zIndex: 1,
            ...overlayCss(data),
          }}
        /> */}

        {/* <BoxAbsolute
          sx={{
            zIndex: 2,
            padding: { xs: '24px', sm: '16px' },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: { xs: 'flex-end', sm: 'space-between' },
            alignItems: 'stretch',
            color: data.textColor,
            overflow: 'hidden',
            gap: { xs: '30px', sm: '0' },
          }}
        >
          <Stack direction="column" alignItems="flex-start" gap="10px">
            {data.title && (
              <Typography
                fontSize="20px"
                lineHeight="32px"
                fontWeight={600}
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: '2', // Number of lines to show
                  WebkitBoxOrient: 'vertical',
                }}
              >
                {string.truncate(data.title, 50)}
              </Typography>
            )}
            {data.description && (
              <Typography
                lineHeight="24px"
                fontWeight={400}
                sx={{
                  opacity: 0.7,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: '3', // Number of lines to show
                  WebkitBoxOrient: 'vertical',
                }}
              >
                {string.truncate(data.description, 80)}
              </Typography>
            )}
          </Stack>

          <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              opacity: '0.7',
              cursor: 'pointer',
              '& svg': {
                marginInlineStart: '6px',
                marginInlineEnd: '4px',
                transition: 'all 0.3s ease-in-out',
              },
              '&:hover': {
                opacity: '1',
                '& svg': {
                  marginInlineStart: '10px',
                  marginInlineEnd: '0px',
                },
              },
            }}
          >
            <Typography
              sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
              onClick={data.onClick}
            >
              {string.truncate(data.cta || t('labels.learnMore'), 20)}
            </Typography>
            <Svg
              Icon={direction === 'rtl' ? ChevronLeft : ChevronRight}
              sx={{
                color: data.textColor,
                width: '20px',
              }}
            />
          </Stack>
        </BoxAbsolute> */}
      </Box>
    </>
  );
}
